<div class="main">
    <div class="section">
        <div class="header">
            
            <div class="filtersBody">
                <div class="label">Invoices</div>
                <div class="filters">
                    <div class="input">
                        <input type="text" class="inputField" placeholder="From" (click)="fromDateInput1.open()"
                            [matDatepicker]="fromDateInput1" [(ngModel)]="fromDate" />
                        <mat-datepicker #fromDateInput1 (closed)="getConsolidatedInvoices();getConsolidatedStatus()"></mat-datepicker>
                        <span class="material-icons dateIcon">
                            <img src="assets/calender-icon-modenik.svg" alt="Calender"> </span>
                    </div>
                    <div class="input">
                        <input type="text" class="inputField" placeholder="To" (click)="toDateInput1.open()"
                            [matDatepicker]="toDateInput1" [(ngModel)]="toDate" />
                        <mat-datepicker #toDateInput1 (closed)="getConsolidatedInvoices();getConsolidatedStatus()"></mat-datepicker>
                        <span class="material-icons dateIcon">
                            <img src="assets/calender-icon-modenik.svg" alt="Calender"> </span>
                    </div>
                    <div class="item">
                        <input type="text" (keyup)="getConsolidatedInvoices()" class="inputSelect" [(ngModel)]="plantCode"
                            placeholder="Plant Code">
                    </div>
                    <div class="item">
                        <input type="text" class="inputSelect" placeholder="Shipper" [matAutocomplete]="carrierSelect" [(ngModel)]="selectedShipperName">
                        <mat-autocomplete [panelWidth]="600" #carrierSelect="matAutocomplete">
                            <mat-option *ngFor="let option of shippers | filter: selectedShipperName" [value]="option.parent_name" (click)="selectShipper(option)">
                                <span>{{option.parent_name}}</span>
                            </mat-option>
                        </mat-autocomplete>
                        <div class="clear_icon" *ngIf="selectedShipper">
                            <img src="assets/clear_icon.svg" alt="" (click)="selectedShipper = '';selectedShipperName = ''; getConsolidatedInvoices();"
                                title="Clear">
                        </div>
                    </div>
                    <div class="item">
                        <input type="text" (keyup)="getConsolidatedInvoices()" class="inputSelect" [(ngModel)]="invoiceNumber"
                            placeholder="Invoice Number">
                    </div>
                    <!-- <div class="item consolidate_invoice_select">
                        
                        <mat-form-field appearance="outline" style="outline: none;">
                            <mat-label style="font-size: 12px !important;top: -6px;position: relative;">{{'Status' |translate}}</mat-label>
                            <mat-select [(ngModel)]="selectedStatus">
                                <mat-option *ngFor="let option of statuses" [value]="option.value" (click)="selectStatus(option)">
                                  {{option.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="clear_icon" *ngIf="selectedStatus">
                            <img src="assets/clear_icon.svg" alt="" (click)="selectedStatus = ''; getConsolidatedInvoices();"
                                title="Clear">
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="right">
                <div  class="icons" (click)="download()"><img alt="" src="assets/download-icon-new copy.svg"></div>
                <div (click)="getConsolidatedInvoices();getConsolidatedStatus()" style="cursor: pointer;">
                    <img src="assets/refresh_new.svg" alt="">
                </div>
            </div>
            
        </div>
        <div class="cards_main">
            <div class="card" *ngFor="let status of statuses" (click)="onStatusCardClick(status.value)">
                <div class="card_body"  [ngStyle]="{'background-color': (status.isActive ? getColor(status.value) : '#fff'),'color': (status.isActive ? 'white' : '#42454E')}">
                    <div> <img [src]="status.isActive ? status.activeIcon : status.inactiveIcon" alt=""> </div>
                    <div class="card_content">
                        <div class="title_text" [ngStyle]="{'color': (status.isActive ? '#F4F4F4' : '#42454E')}">{{status.name}}</div>
                        <div class="count" [ngStyle]="{'color': (status.isActive ? '#F4F4F4' : '#42454E')}">{{status.count || 0}}</div>
                        <div class="price" [ngStyle]="{'color': (status.isActive ? '#F4F4F4' : '#42454E')}"> ₹ {{status.total || 0  | numberFormat}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="body">
            
            <div class="table">
                <table mat-table [dataSource]="dataSource">
                    <!-- Sno Column -->
                    <ng-container matColumnDef="sno">
                        <th mat-header-cell *matHeaderCellDef>Sno</th>
                        <td mat-cell *matCellDef="let item">{{ item.sno }}</td>
                    </ng-container>
                
                    <!-- Date Column -->
                    <ng-container matColumnDef="Date">
                        <th mat-header-cell *matHeaderCellDef>Date</th>
                        <td mat-cell *matCellDef="let item">{{ item.date }}</td>
                    </ng-container>
                
                    <!-- Plant Code Column -->
                    <ng-container matColumnDef="plantCode">
                        <th mat-header-cell *matHeaderCellDef>Plant Code</th>
                        <td mat-cell *matCellDef="let item">{{ item.plantCode }}</td>
                    </ng-container>
                
                    <!-- Freight Amount Column -->
                    <ng-container matColumnDef="freightAmount">
                        <th mat-header-cell *matHeaderCellDef>Freight Amount</th>
                        <td mat-cell *matCellDef="let item">{{ item.freightAmount }}</td>
                    </ng-container>
                
                    <!-- Shipper Name Column -->
                    <ng-container matColumnDef="ShipperName">
                        <th mat-header-cell *matHeaderCellDef>Shipper Name</th>
                        <td mat-cell *matCellDef="let item">{{ item.shipperName }}</td>
                    </ng-container>
                
                    <!-- Custom Invoice Number Column -->
                    <ng-container matColumnDef="customInvoiceNumber">
                        <th mat-header-cell *matHeaderCellDef>Custom Invoice Number</th>
                        <td mat-cell *matCellDef="let item" >
    <div style="    display: flex;
    align-items: center;">
                            <a [href]="item.pdfLink" target="_blank" *ngIf="item.pdfLink">{{ item.customInvoiceNumber }}</a>
                            <span *ngIf="!item.pdfLink" >{{ item.customInvoiceNumber }}</span>
                        <mat-icon *ngIf="item.attachments.length">attachment</mat-icon>
                        </div>
                        </td>
                    </ng-container>
                
                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let item">{{ item.status }}</td>
                    </ng-container>

                    <ng-container matColumnDef="approvedBy">
                        <th mat-header-cell *matHeaderCellDef>Approved By</th>
                        <td mat-cell *matCellDef="let item">{{ item.approvedBy }}</td>
                    </ng-container>
                    
                    <!-- <ng-container matColumnDef="comments">
                        <th mat-header-cell *matHeaderCellDef>Comments</th>
                        <td mat-cell *matCellDef="let item">{{ item.comments }}</td>
                    </ng-container> -->

                    <ng-container matColumnDef="comments">
                        <th mat-header-cell *matHeaderCellDef>Comments</th>
                        <td mat-cell *matCellDef="let item">
                          Transporter:  {{ item.carrier_comments }} <br>
                          Shipper:  {{ item.shipper_comments }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>
                            <!-- <div class="input">
                                                  <input type="text" placeholder="Bill Cycle">
                                              </div> -->
                            {{'CREATE_BILLS.actions' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-icon class="more-icon" [matMenuTriggerFor]="actions" (click)="$event.stopPropagation()">more_horiz
                            </mat-icon>
                            <mat-menu #actions="matMenu">
                                <button mat-menu-item
                                    (click)="$event.stopPropagation(); openCreateDebitDialog(element, 'Debit')">Create Debit Note</button>
                                <button mat-menu-item
                                    (click)="$event.stopPropagation(); openCreateDebitDialog(element, 'Credit')">Create Credit Note</button>
                                <button mat-menu-item (click)="openAttachmentUploader(element,'attachment')">Upload Attachment</button>
                                <button mat-menu-item (click)=" openselectSInDialog(element)">
                                    View Epod</button>
                                <!-- <button mat-menu-item (click)="$event.stopPropagation(); openFileUploader(element)">Upload ePOD</button> -->
                            </mat-menu>
                        </td>
                        <!-- <td  mat-cell *matCellDef="let element"> <a class="invoice_text" href="{{element.invoice_link}}">{{element.invoice_pdf}}</a></td> -->
                    </ng-container>
                
                    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="openInvoiceDetails(row)"></tr>
                </table>
            </div>
            <div style="position: fixed;width: 97%;bottom: 0;">
                <mat-paginator [length]="(dataSource.length)? totalInvoices: 0" [pageSizeOptions]="[10,25,50,100]" showFirstLastButtons
                (page)="pageNavigate($event)"></mat-paginator>
            </div>
            
        </div>
    </div>
</div>

<ng-template #selectSinDialog>
    <div class="dialogMain">
        <div class="section">
            <div class="header">
                <div class="label">
                    Select Shipment
                </div>
                <div class="close">
                    <button mat-icon-button class="close-button" (click)="dialogSelectSinRef.close()">
                        <img src="assets/popup_close_icon.svg" alt="">
                    </button>
                </div>
            </div>
            <div class="body">
                <div class="inputContainer do_number_select" style="border: 0;">
                    <mat-form-field appearance="outline" style="outline: none;width: 100%;">
                        <mat-label placeholder="DO Number(s)"
                        style="font-size: 12px !important;font-weight: bold;position: relative;top: -6px;">DO Number(s)</mat-label>
                    <mat-select class="inputSelect" [placeholder]="'DO Number(s)'" [(ngModel)]="selectedSin">
                        <input matInput  (keyup)="applyFilter($event.target.value)" placeholder="Search DO Numbers" style="outline: none;
                            height: 24px;
                            border: solid 1px #e3e3e3;
                            width: 93%;
                            margin: 2%;
                            border-radius: 4px;
                            padding-left: 6px;
                            font-size: 14px;
                            color: #42454E;">
                        <mat-option *ngFor="let sin of filteredOptions" [value]="sin._id">
                          {{sin.do_numbers}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>
                <div class="buttons">
                    <div class="newButton"
                        (click)="getShipmentDetails(selectedSin)">
                        <div class="label">
                            View Epod(s)
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>